import { render } from "./UpdateFormTicketsTestBootstrapNov16.vue?vue&type=template&id=3f4c8314"
const script = {}

import "./UpdateFormTicketsTestBootstrapNov16.vue?vue&type=style&index=0&id=3f4c8314&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__